import { 
    Cartesian3, 
    GeometryInstance, 
    PerInstanceColorAppearance, 
    PolygonGeometry, 
    PolygonHierarchy, 
    Primitive,
    ColorGeometryInstanceAttribute
} from "cesium"
import { changeColor } from '@/utils/custom-utils'

export default class PolygonPrimitive {

    /**
     * 
     * @param {Object} options 
     * @param {String} [options.fillColor] 填充色
     * @param {String} [options.outlineColor] 外边框色
     * @param {Number} [options.outlineWidth] 外边框宽度
     */
    constructor(options) {
        this.points = []
        this.options = Object.assign({
            fillColor: '#FFFFFF',
            fillOpacity: 0.5
        }, options)
    }

    setPoints(points) {
        this.points.length = 0
        for(let i=0; i<points.length; i++) {
            this.points.push(...points[i])
        }
    }

    getInstances() {
        let geometryInstances = []
        if(!(this.points && this.points.length>0)){
            return geometryInstances
        }

        // 圆
        const circleFillInstance = new GeometryInstance({
            geometry: new PolygonGeometry({
                polygonHierarchy: new PolygonHierarchy(Cartesian3.fromDegreesArray(this.points)),
                vertexFormat: PerInstanceColorAppearance.VERTEX_FORMAT
            }),
            attributes: {
                color: ColorGeometryInstanceAttribute.fromColor(changeColor(this.options.fillColor).withAlpha(this.options.fillOpacity))
            }
        })
        geometryInstances.push(circleFillInstance)
        return geometryInstances
    }

    update(context, frameState, commandList) {
        const instances = this.getInstances()
        if(instances.length === 0) {
            return
        }
        this._primitive = new Primitive({
            geometryInstances: instances,
            appearance: new PerInstanceColorAppearance({
                translucent: true,
                closed: false,
                renderState: {
                    depthTest: {
                        enabled: true
                    }
                }
            }),
            asynchronous: false,
            releaseGeometryInstances: false
        })
        const primitive = this._primitive
        primitive.update(context, frameState, commandList)
    }
}